import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GoogleUserModel } from '../../../models/google.user.model';
import { AuthService } from 'angular2-social-login';
import { IdentificationStepsService } from '../../../../payment/services/identification-steps.service';

@Component({
    selector: 'social-login-button-google',
    templateUrl: './social-login-button.google.component.html',
    styleUrls: ['../../../../payment/payment.component.scss']
})
export class SocialLoginButtonGoogleComponent {
    @Input('disabled') disabled: boolean;
    public allowed = false;

    constructor(
        protected socialAuthService: AuthService,
        protected activatedRoute: ActivatedRoute,
        protected identificationStepsService: IdentificationStepsService
    ) {
        this.activatedRoute.data.map((data) => {
            return data.storeConfigurations;
        }).subscribe((data) => {
            this.allowed = this.isAllowed(data);
        });
    }

    /**
     * Verify if google login is allowed
     **/
    private isAllowed(data) {
        return data['checkout.identification.login.social_network.google'] !== undefined
            && data['checkout.identification.login.social_network.google'] !== null
            && data['checkout.identification.login.social_network.google'] === '1';
    }

    /**
     * Call Google Plus login.
     * */
    public gpLogin() {
        window.location.href='/ecommerce/identification/to-janus/google';
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/shared/components/social-login-button/google/social-login-button.google.component.ts